export default function HeroSection() {
  const scrollToCalculator = () => {
    const calculatorSection = document.querySelector('#pricing-calculator');
    if (calculatorSection) {
      calculatorSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative bg-stone-900 text-white py-24">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/26971a37f2c1e9a1069451e2c014994b.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      
      <div className="relative max-w-5xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          Transparent Pricing, Fast Quotes
        </h1>
        <p className="text-xl md:text-2xl text-stone-200 mb-10 max-w-3xl mx-auto">
          Use the calculator to estimate cost by site size. Final quotes reflect layout, access, and reporting needs.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={scrollToCalculator}
            className="bg-emerald-600 text-white px-8 py-4 rounded-md text-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap"
          >
            Estimate Your Price
          </button>
          <a
            href="/instant-quote"
            className="bg-white text-stone-900 px-8 py-4 rounded-md text-lg font-semibold hover:bg-stone-100 transition-colors whitespace-nowrap"
          >
            Request a Quote
          </a>
        </div>
      </div>
    </section>
  );
}
